module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination"
  }, [_c('pagination', {
    attrs: {
      "total": _vm.total,
      "current-page": _vm.current
    },
    on: {
      "pagechange": _vm.pagechange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d4ebb7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/chat/chat.vue
// module id = 510
// module chunks = 1